export default __webpack_public_path__ + "static/media/blue-people.99c02207.svg";